/**
 * URL de base API pour les pages utilisant axios directement.
 * Toujours préférer apiClient / getApiBase() plutôt que process.env.REACT_APP_BACKEND_URL.
 */
import { getApiBase } from '../services/api/config'

export default getApiBase()
